import {
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import userImage from "../../../src/assets/user.jpg";
export default function UserProfileCard({ data, callBack }) {
  return (
    <Card
      sx={{
        width: "100%",
        mb: 0,
        mt: "8px",
        p: "0px",
        backgroundColor: "#EEEEFF",
        cursor: "pointer",
        // ":hover": {
        //   bgcolor: "#2892ba17",
        // },
      }}
      onClick={callBack}
      //   onClick={setEditedItem}
    >
      <CardContent sx={{ p: "0px 1px !important" }}>
        <Grid
          container
          sx={{
            display: "flex",
            alignItems: "center",
            pl: { xs: "2px", sm: "10px" },
          }}
        >
          {/* <Box mr={4}>
            <img
              src={userImage}
              alt="User Image"
              style={{
                width: "100%",
                height: "50px",
              }}
            />
          </Box> */}
          <Grid
            item
            xs={12}
            sx={{
              borderRadius: "8px",
              padding: "10px",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
              fontWeight: "bold",
              color: "#001858",
              display: "flex",
              justifyContent: "space-between",
              px:{xs:4, sm:4, md:4, lg:8}
            }}
          >
            <Typography
              color="#01008B"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // overflow: "Hidden",
                // textOverflow: "ellipsis",
                // display: "-webkit-box",
                // "-webkit-line-clamp": "1",
                // "-webkit-box-orient": "vertical",
                fontWeight: 600,
              }}
            >
              {data?.name}
            </Typography>
            <Typography
              color="#01008B"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // overflow: "Hidden",
                // textOverflow: "ellipsis",
                // display: "-webkit-box",
                // "-webkit-line-clamp": "1",
                // "-webkit-box-orient": "vertical",
                fontWeight: 500,
              }}
            >
              {data?.mobileNumber}
            </Typography>
            {/* <Typography sx={{ fontSize: "14px" }}> {data?.mobile}</Typography> */}
          </Grid>
         
        </Grid>
      </CardContent>
    </Card>
  );
}
